import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  parentBox: {
    backgroundColor: "#F4F4F5",
    borderRadius: "8px",
    margin: "10px 0",
  },
  childBox: {
    backgroundColor: "#F4F4F5",
    color: "#000",
    height: "auto",
    borderRadius: "7px",
    padding: "15px",
  },
  grandChild: {
    width: "100%",
    height: "auto",
  },
  gridStyling: {
    margin: 0,
    "@media (max-width:768px)": {
      textAlign: "center",
    },
  },
  numbersStyling: {
    color: "#000", // Black
    fontFamily: "Inter, sans-serif",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "44px",
    letterSpacing: "-0.72px",
  },
  gridBorder: {
    borderRight: "1px solid #A1A1AA",
    "@media (max-width:768px)": {
      borderRight: "none",
      borderBottom: "1px solid #A1A1AA",
    },
  },
  specialGridBorder: {
    borderRight: "1px solid #A1A1AA",
    "@media (max-width:768px)": {
      borderBottom: "1px solid #A1A1AA",
    },
    "@media (max-width:1199px)": {
      borderRight: "none",
    },
  },
  gridPaddingLeft: {
    paddingLeft: "40px",
    "@media (max-width:1199px)": {
      paddingLeft: "16px",
    },
  },
  label: {
    color: "#71717A", // Neutral-500
    fontFamily: "Inter, sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "28px",
  },
  billingText: {
    color: "#000", // Black-Default
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
}));

export default useStyles;
